import { render } from "./Total_Collections_View.vue?vue&type=template&id=2f753527&scoped=true"
import script from "./Total_Collections_View.vue?vue&type=script&lang=js"
export * from "./Total_Collections_View.vue?vue&type=script&lang=js"

import "./Total_Collections_View.vue?vue&type=style&index=0&id=2f753527&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2f753527"]])

export default __exports__